// eslint-disable-next-line no-unused-vars
import BiodataRepository from '../../../domain/repositories/BiodataRepository';

class UpdateBiodataStatusUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @param {string} biodataId
     * @param {string} newStatus
     * @returns {Promise<void>}
     */
    async execute(biodataId, newStatus) {
        return this.biodataRepository.updateBiodataStatus(biodataId, newStatus);
    }
}

export default UpdateBiodataStatusUseCase;
